<template>
  <div class="medication-request-dispense-history">
    <div class="medication-request-dispense-history__body">
      <div v-for="medicationDispense in formattedMedicationDispenseGroup" :key="`medication-dispense-${medicationDispense.id}`" class="card">
        <div class="card-body">
          <dl class="card-body__details">
            <dt>Lugar de dispensación</dt>
            <dd>{{ medicationDispense.location }}</dd>
            <dt>Dispensado por:</dt>
            <dd>{{ medicationDispense.performerDisplay }}</dd>
            <dt>Fecha</dt>
            <dd>{{ medicationDispense.date | dateTime }}</dd>
            <dt>Producto Dispensado</dt>
            <dd>{{ medicationDispense.display }}</dd>
            <dt>Cantidad</dt>
            <dd>{{ medicationDispense.quantityValue }} {{ getLabelUnit(medicationDispense.quantityValue) }}</dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _get from 'lodash/get';

export default {
  name: 'MedicationRequestDispenseHistory',
  props: {
    medicationRequest: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedMedicationDispenseGroup() {
      return _get(this.medicationRequest, 'medicationDispenses', []).map(medicationDispense => {
        return {
          id: medicationDispense.id,
          display: _get(medicationDispense, 'data.medicationReference.display', ''),
          date: _get(medicationDispense, 'created_at', ''),
          performerDisplay: _get(medicationDispense, 'data.performer[0].actor.display', '-'),
          quantityValue: _get(medicationDispense, 'data.quantity.value', ''),
          quantityCode: _get(medicationDispense, 'data.quantity.code', ''),
          location: `${_get(medicationDispense, 'data.location.name', '')} - ${_get(medicationDispense, 'data.location.identifier', '')} - ${_get(medicationDispense, 'data.location.address', '')}`
        };
      });
    }
  },
  methods: {
    getLabelUnit(val) {
      return (val > 1)
        ? 'unidades'
        : 'unidad';
    }
  }
};
</script>

<style lang="scss">
.medication-request-dispense-history {
  &__body {
    .card {
      margin-bottom: $--spacing-4;
    }
  }
}
</style>
